import { analyticsReport } from "@dataseat-dsp-client/lib-reporter";

export type DimensionAsMeasureType = analyticsReport.DimensionAsMeasureType;

export const dimensionsAsMeasuresDict =
  analyticsReport.dimensionsAsMeasuresDict;
